'use-client';
import * as React from 'react';
import WPhoto from '../../WPhotoBase';
import type { SkinWPhotoProps } from '../SkinWPhoto';
import type { BaseWPhotoSkinProps } from '../../../WPhoto.types';
import skinsStyles from './styles/ScotchDoubleVertical.scss';
import ScotchDoubleSkin from './ScotchDoubleSkin';

const ScotchDoubleVerticalSkin: React.FC<
  Omit<BaseWPhotoSkinProps, 'skinsStyle'>
> = props => <ScotchDoubleSkin {...props} skinsStyle={skinsStyles} />;

const ScotchDoubleVertical: React.FC<SkinWPhotoProps> = props => (
  <WPhoto {...props} skin={ScotchDoubleVerticalSkin} />
);

export default ScotchDoubleVertical;
